import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDrawer,
      expression: "clickOutsideDrawer"
    }],
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: _vm.drawerWidth,
      temporary: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v(_vm._s(_vm.order.reference_order.shorterReference()) + " to ship. Brokerage")])], 1)]), _vm.hasParentContainerBeforeMerge ? _c(VAlert, {
    staticClass: "--small",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange",
      text: ""
    }
  }, [_vm._v(" The parent container order must be in a more advanced status ")]) : [_c(VStepper, {
    key: _vm.steps.length,
    attrs: {
      vertical: ""
    },
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_vm._l(_vm.steps, function (step) {
    var _vm$order$items;
    return [_c("div", {
      key: "step_".concat(step.id)
    }, [_c(VStepperStep, {
      attrs: {
        step: step.id,
        complete: _vm.currentStep > step.id,
        rules: step.rules,
        editable: ""
      }
    }, [_vm._v(" " + _vm._s(step.title) + " "), _c("small", [_vm._v(_vm._s(step.inf))])]), step.key === "containerSuborders" ? _c(VStepperContent, {
      key: "shipment_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_vm.isContainerOrderWithAnySuborderNotValidated ? _c("div", {
      staticClass: "flex mb-2"
    }, [_c(VAlert, {
      staticClass: "--small text-left",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_c("div", [_vm._v(" All suborders must have been validated. After validations, you must reload the container order page to view the updated information ")])])], 1) : _vm._e(), _vm.isContainerOrderWithAnySuborderNotFullyCalculated ? _c("div", {
      staticClass: "flex mb-2"
    }, [_c(VAlert, {
      staticClass: "--small text-left",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_c("div", [_vm._v(" All suborders must not be in modification. You must reload the suborder page, quit it, and reload the container order page to view the updated information ")])])], 1) : _vm._e(), _vm.isContainerOrderWithAnySuborderPricePostingNotMatch ? _c("div", {
      staticClass: "flex mb-2"
    }, [_c(VAlert, {
      staticClass: "--small text-left",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "blue",
        text: ""
      }
    }, [_c("div", [_vm._v(" Some posting month of suborders don't match with the container order posting month. Please verify the legal compliance of these suborders. After the suborder's updates, you must reload the container order page to view the updated information ")])])], 1) : _vm._e(), _c("div", [_c(VDataTable, {
      staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
      attrs: {
        headers: _vm.subordersTableHeaders,
        items: _vm.order.containerSubOrders,
        "items-per-page": -1,
        "loading-text": "Loading... Please wait",
        "hide-default-footer": "",
        "disable-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "item.reference",
        fn: function fn(_ref) {
          var item = _ref.item;
          return [_c("div", {
            staticClass: "ml-1"
          }, [_c("router-link", {
            staticClass: "router-link",
            attrs: {
              to: _vm.orderDetails(item.id_order),
              target: "_blank"
            }
          }, [_vm._v(" " + _vm._s(item.reference_order.shorterReference()) + " ")])], 1), _c("div", [_c("span", {
            class: ["badge line-height-1_1", item.status === _vm.orderStatus.find(function (x) {
              return x.id === "CANCELLED";
            }).status ? "danger" : item.status === _vm.orderStatus.find(function (x) {
              return x.id === "VALIDATED";
            }).status || item.status === _vm.orderStatus.find(function (x) {
              return x.id === "IN_PREPARATION";
            }).status ? "success" : "warning"]
          }, [_vm._v(" " + _vm._s(_vm.getOrderStatusLabel(item.status)) + " ")])])];
        }
      }, {
        key: "item.orderData",
        fn: function fn(_ref2) {
          var _vm$order$pricePostin, _item$pricePostingUsa, _item$pricePostingUsa2;
          var item = _ref2.item;
          return [((_vm$order$pricePostin = _vm.order.pricePostingUsaPro) === null || _vm$order$pricePostin === void 0 ? void 0 : _vm$order$pricePostin.id) > 0 ? _c("div", [item.pricePostingUsaPro == null ? _c("span", {
            staticClass: "badge info"
          }, [_vm._v(" No price posting ")]) : ((_item$pricePostingUsa = item.pricePostingUsaPro) === null || _item$pricePostingUsa === void 0 ? void 0 : _item$pricePostingUsa.id) > 0 && ((_item$pricePostingUsa2 = item.pricePostingUsaPro) === null || _item$pricePostingUsa2 === void 0 ? void 0 : _item$pricePostingUsa2.id) != _vm.order.pricePostingUsaPro.id ? _c("span", {
            staticClass: "badge warning"
          }, [_vm._v(" Posting month NOT MATCH ")]) : _c("span", {
            staticClass: "badge success"
          }, [_vm._v("Posting month MATCH")])]) : _vm._e(), !item.isFullyCalculatedAmounts ? _c("div", [_c("span", {
            staticClass: "badge error"
          }, [_vm._v("Seems to still be in modification")])]) : _vm._e()];
        }
      }, {
        key: "item.user",
        fn: function fn(_ref3) {
          var item = _ref3.item;
          return [_c("div", {
            domProps: {
              innerHTML: _vm._s(String.parseForVHtml(_vm.getFullNameUserHtml(item.user, true, true)))
            }
          })];
        }
      }, {
        key: "item.deliveryAddress",
        fn: function fn(_ref4) {
          var _item$delivery_addres;
          var item = _ref4.item;
          return [item.isSubcontainerPutInbound ? _c("div", {
            staticClass: "text-italic"
          }, [_vm._v(" Put Inbound ")]) : [_c("div", {
            staticClass: "text-smaller text-italic text-underline"
          }, [_vm._v("Direct delivery")]), _c("div", [_vm._v(" " + _vm._s("".concat(item.delivery_address.city, ", ").concat(item.delivery_address.country.iso_code).concat((_item$delivery_addres = item.delivery_address.state) !== null && _item$delivery_addres !== void 0 && _item$delivery_addres.iso_state ? "-" + item.delivery_address.state.iso_state : "")) + " ")])]];
        }
      }, {
        key: "item.amount",
        fn: function fn(_ref5) {
          var item = _ref5.item;
          return [_vm._v(" " + _vm._s(_vm.formatPrice(item.total_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(item.currency)) + " ")];
        }
      }], null, true)
    }), _c("div", {
      staticClass: "text-smaller mt-1"
    }, [_c("div", {
      staticClass: "flex justify-end"
    }, [_c("div", [_vm._v("Suborders Nb Bottles :")]), _c("div", {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(_vm.order.containerSubOrdersQuantity))])]), _c("div", {
      staticClass: "flex justify-end"
    }, [_c("div", [_vm._v("Suborders Total :")]), _c("div", {
      staticClass: "text-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.containerSubOrdersTotalAmountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])]), ((_vm$order$items = _vm.order.items) === null || _vm$order$items === void 0 ? void 0 : _vm$order$items.length) > 0 ? [_c("div", {
      staticClass: "flex justify-end mt-4"
    }, [_c("div", [_vm._v("Global Nb Bottles :")]), _c("div", {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(_vm.order.containerGlobalQuantity))])]), _c("div", {
      staticClass: "flex justify-end"
    }, [!_vm.order.isFullyCalculatedAmounts ? _c("div", {
      staticClass: "text-italic"
    }, [_vm._v(" Amounts recalculation needed ")]) : [_c("div", [_vm._v("Global Total :")]), _c("div", {
      staticClass: "text-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.containerGlobalTotalAmountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])]], 2)] : _vm._e()], 2)], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        disabled: _vm.isContainerOrderWithAnySuborderNotValidated || _vm.isContainerOrderWithAnySuborderNotFullyCalculated
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)]) : _vm._e(), step.key === "shipment" ? _c(VStepperContent, {
      key: "shipment_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_c("OrderShipmentList", {
      ref: "deliveryDrawerOrderShipmentRef",
      refInFor: true,
      attrs: {
        order: _vm.order,
        withAddbutton: ""
      },
      on: {
        shipmentsChanged: _vm.shipmentsChanged
      }
    }), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "step-tracking-continue-btn"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)], 1) : _vm._e(), step.key === "mail" ? _c(VStepperContent, {
      key: "mail_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_c(VExpansionPanels, {
      on: {
        change: _vm.changePanel
      },
      model: {
        value: _vm.openedPanel,
        callback: function callback($$v) {
          _vm.openedPanel = $$v;
        },
        expression: "openedPanel"
      }
    }, _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
      return _c(VExpansionPanel, {
        key: "expansion-panel_".concat(i),
        attrs: {
          id: "expansion-panel_".concat(i)
        }
      }, [_c(VExpansionPanelHeader, [_c(VBtn, {
        staticClass: "expansion-panel-header-close-btn",
        attrs: {
          icon: "",
          "data-cy": "step-mail-close-btn"
        },
        on: {
          click: function click($event) {
            return _vm.deleteTemplatePanel(i);
          }
        }
      }, [_c(VIcon, [_vm._v("mdi-close")])], 1), _vm._v(" " + _vm._s(emailTemplate.name) + " ")], 1), _c(VExpansionPanelContent, [!_vm.flattenPlaceholders.length ? _c(VSkeletonLoader, {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          type: "image"
        }
      }) : [_vm.isNeedingSync ? _c(VBtn, {
        staticClass: "sync-btn",
        attrs: {
          rounded: "",
          loading: _vm.isSyncing
        },
        on: {
          click: _vm.syncLatestVersion
        }
      }, [_c(VIcon, [_vm._v("mdi-lightning-bolt")]), _vm._v(" Sync latest version ")], 1) : _vm._e(), _vm.openedPanel === i ? _c("MailTemplateForm", {
        key: "step_template_".concat(emailTemplate.id, "_").concat(i),
        attrs: {
          order: _vm.order,
          placeholders: _vm.emailPlaceholders,
          templates: _vm.emailTemplates,
          documents: _vm.documents,
          isDeletingTemplate: _vm.isDeletingTemplate
        },
        on: {
          edit: _vm.editTemplate,
          delete: _vm.deleteTemplate,
          change: _vm.changeTemplate,
          "click:new": _vm.newTemplate,
          "click:placeholder": _vm.clickPlaceholder
        },
        model: {
          value: _vm.form.emailTemplates[i],
          callback: function callback($$v) {
            _vm.$set(_vm.form.emailTemplates, i, $$v);
          },
          expression: "form.emailTemplates[i]"
        }
      }) : _vm._e()]], 2)], 1);
    }), 1), _c(VBtn, {
      staticClass: "new-email-btn",
      attrs: {
        rounded: ""
      },
      on: {
        click: _vm.newEmail
      }
    }, [_c(VIcon, [_vm._v("mdi-plus")]), _vm._v(" new e-mail ")], 1), _c(VDivider), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "step-mail-continue-btn"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)], 1) : _vm._e(), step.key === "synthesis" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [!_vm.order.isPreventInvoice && !_vm.order.isInvoiced ? _c("div", {
      staticClass: "text-left mb-4"
    }, [_vm._v(" The C&M invoice will be generated during this step. ")]) : _vm._e(), _vm.order.initialOrderId ? _c("div", {
      staticClass: "d-flex align-center mb-4"
    }, [_vm._v(" Order created from "), _c("router-link", {
      staticClass: "router-link ml-2",
      attrs: {
        to: _vm.orderDetails(_vm.order.initialOrderId)
      }
    }, [_vm._v(" " + _vm._s(_vm.order.initialOrderReference.shorterReference()) + " ")])], 1) : _vm._e(), _vm.orderChildren.length > 0 ? _c("div", [_vm.orderChildren.length == 1 ? _c("div", {
      staticClass: "d-flex align-center"
    }, [_vm._v(" Order associated "), _c("router-link", {
      staticClass: "router-link ml-2",
      attrs: {
        to: _vm.orderDetails(_vm.orderChildren[0].id_order)
      }
    }, [_vm._v(" " + _vm._s(_vm.orderChildren[0].reference_order.shorterReference()) + " ")])], 1) : _c("div", {
      staticClass: "d-flex align-center"
    }, [_vm._v("Orders associated")]), _vm.orderChildren.length > 1 ? _c("ul", {
      staticClass: "order-children"
    }, _vm._l(_vm.orderChildren, function (item) {
      return _c("li", {
        key: "order-".concat(item.id_order),
        staticClass: "text-smaller"
      }, [_c("router-link", {
        staticClass: "router-link",
        attrs: {
          to: _vm.orderDetails(item.id_order)
        }
      }, [_vm._v(" " + _vm._s(item.reference_order.shorterReference()) + " ")])], 1);
    }), 0) : _vm._e()]) : _vm._e(), _vm.isInvalidForm ? _c("div", {
      staticClass: "errorLabel text-sm"
    }, [_c("p", [_vm._v("Make sure you have completed all the previous step.")]), _vm._l(_vm.errorsForm, function (error, i) {
      return _c("div", {
        key: "mainError-".concat(i)
      }, [_vm._v(" " + _vm._s(error) + " ")]);
    })], 2) : [_c("div", {
      staticClass: "mt-4"
    }, [_c("div", {
      staticClass: "text-smaller text-italic text-left"
    }, [_vm._v(" Mail title : Your order is being delivered ")]), _c("div", {
      staticClass: "d-flex align-center"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: _vm.preventNotifyCustomer,
        callback: function callback($$v) {
          _vm.preventNotifyCustomer = $$v;
        },
        expression: "preventNotifyCustomer"
      }
    }), _vm.preventNotifyCustomer ? _c("span", {
      staticClass: "text-red text-bold"
    }, [_vm._v(" WILL NOT NOTIFY THE CUSTOMER BY AUTOMATIC PLATFORM MAIL ")]) : _c("span", {
      staticClass: "text-green text-bold"
    }, [_vm._v(" Will notify customer by automatic platform mail ")])], 1)]), _c("div", {
      staticClass: "hr --gray-400 --small mt-4"
    }), !!_vm.form.emailTemplates.length ? _c("div", {
      staticClass: "mt-6 text-left"
    }, [_c("i", {
      staticClass: "fas fa-envelope mr-1"
    }), _vm._v(" Email(s) "), _c("strong", [_vm._v("(x" + _vm._s(_vm.form.emailTemplates.length) + ")")]), _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
      return _c("div", {
        key: "synthesis_template_".concat(emailTemplate.id),
        staticClass: "text-sm"
      }, [_c(VDivider, {
        staticClass: "my-3"
      }), _c("div", {
        staticClass: "synthesis-email-line"
      }, [_c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isSuccessfulSending["".concat(emailTemplate.id, "_").concat(i)],
          expression: "isSuccessfulSending[`${emailTemplate.id}_${i}`]"
        }],
        staticClass: "sent-container"
      }, [_c("svg", {
        attrs: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 130.2 130.2"
        }
      }, [_c("circle", {
        staticClass: "path circle",
        attrs: {
          fill: "none",
          stroke: "#73AF55",
          "stroke-width": "6",
          "stroke-miterlimit": "10",
          cx: "65.1",
          cy: "65.1",
          r: "62.1"
        }
      }), _c("polyline", {
        staticClass: "path check",
        attrs: {
          fill: "none",
          stroke: "#73AF55",
          "stroke-width": "6",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          points: "100.2,40.2 51.5,88.8 29.8,67.5 "
        }
      })]), _vm._v(" Sent! ")]), _c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.failedCustomMails["".concat(emailTemplate.id, "_").concat(i)],
          expression: "failedCustomMails[`${emailTemplate.id}_${i}`]"
        }],
        staticClass: "sent-container text-center"
      }, [_c("svg", {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "0 0 130.2 130.2"
        }
      }, [_c("path", {
        staticClass: "path",
        attrs: {
          d: "M 10,10 l 90,90 M 100,10 l -90,90",
          stroke: "red",
          "stroke-width": "10"
        }
      })]), _vm._v(" Not send! ")]), _c("div", [_c("div", {
        staticClass: "mt-1"
      }, [_c("strong", [_vm._v(_vm._s(emailTemplate.name) + ":")])]), _c("div", {
        staticClass: "text-italic mb-1",
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(" " + _vm._s(emailTemplate.from) + " "), _c("i", {
        staticClass: "fas fa-paper-plane mx-2",
        staticStyle: {
          "font-size": "0.85rem"
        }
      }), _vm._v(" " + _vm._s(emailTemplate.sendTo && emailTemplate.sendTo.join(", ")) + " ")]), _c("div", {
        staticClass: "text-italic"
      }, _vm._l(emailTemplate.files, function (file) {
        return _c("a", {
          key: "file_".concat(file.id, "_").concat(file.name),
          staticClass: "mr-2",
          attrs: {
            href: !!file.blob ? file.url : _vm.URL.createObjectURL(file),
            target: "_blank"
          }
        }, [_c("i", {
          staticClass: "fas fa-paperclip"
        }), _vm._v(" " + _vm._s(file.id || file.name) + " ")]);
      }), 0)])])], 1);
    })], 2) : _c("div", {
      staticClass: "errorLabel mt-3"
    }, [_vm._v(" No mail has been configured. Are you sure to continue ? ")])], _vm.isContainerOrderWithAnySuborderPricePostingNotMatch ? _c("div", {
      staticClass: "flex mt-3 text-left"
    }, [_c(VAlert, {
      attrs: {
        dense: "",
        outlined: "",
        type: "info",
        color: "orange",
        text: ""
      }
    }, [_vm._v(" A suborder price posting doesn't match. Please verify the legal compliance before updating the container order status ")])], 1) : _vm._e(), _vm.isContainerOrderWithAnySuborderNotValidated ? _c("div", {
      staticClass: "flex mt-3 text-left"
    }, [_c(VAlert, {
      attrs: {
        dense: "",
        outlined: "",
        type: "error",
        color: "red",
        text: ""
      }
    }, [_vm._v(" A suborder has not been validated yet ")])], 1) : _vm._e(), _vm.isContainerOrderWithAnySuborderNotFullyCalculated ? _c("div", {
      staticClass: "flex mt-3 text-left"
    }, [_c(VAlert, {
      attrs: {
        dense: "",
        outlined: "",
        type: "error",
        color: "red",
        text: ""
      }
    }, [_vm._v(" A suborder seems to be still in modification ")])], 1) : _vm._e(), _vm.isIndiviualAndNotPaid(_vm.order) ? _c("div", {
      staticClass: "flex mt-3"
    }, [_c(VAlert, {
      attrs: {
        dense: "",
        outlined: "",
        type: "error",
        color: "red",
        text: ""
      }
    }, [_vm._v(" NOT PAID : This order has not been paid, and it's for an individual. Ship this order anyway ? ")])], 1) : _vm._e(), _c(VExpandTransition, [_vm.hasFailedSending ? _c(VAlert, {
      staticClass: "--error my-2",
      attrs: {
        type: "error",
        outlined: "",
        dense: ""
      }
    }, [_vm._v(' Some custom emails were not sent! You must use the button "Send mail" on top of order details to resend them. ')]) : _vm._e()], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        loading: _vm.isValidatingOrder,
        disabled: _vm.isInvalidForm || _vm.hasFailedSending,
        "data-cy": "step-synthesis-continue-btn"
      },
      on: {
        click: _vm.validateMain
      }
    }, [_vm._v(" " + _vm._s(_vm.form.emailTemplates.length > 0 ? "Save & Send" : "Save") + " ")])], 1), _vm.isContainerOrder && _vm.isValidatingOrder ? _c("div", {
      staticClass: "text-smaller text-italic text-left"
    }, [_vm._v(" It may take a while, please wait a moment ")]) : _vm._e()], 2) : _vm._e()], 1)];
  })], 2)]], 2), _vm.templateModalShown ? _c("MailTemplateModal", {
    attrs: {
      shown: _vm.templateModalShown,
      placeholders: _vm.emailPlaceholders,
      template: _vm.editableTemplate
    },
    on: {
      save: _vm.saveTemplate,
      close: _vm.closeTemplateModal
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };